import type { RouteOrderDto, TransportRouteSummaryDto } from '../../types/transport';
import { buildTransportRouteLabel } from '../orders/transportAddressUtils';

export function buildTransportOrderRouteLabel(transport: TransportRouteSummaryDto, routeOrder: RouteOrderDto) {
  const choose = (saved: string | null | undefined, addresses: string[], hint?: string | null) => {
    if (saved && addresses.includes(saved)) return [saved];
    if (addresses.length === 1) return addresses;
    if (hint && addresses.includes(hint)) return [hint];
    return [];
  };
  return buildTransportRouteLabel(
    choose(routeOrder.loadingAddress, transport.loadingAddresses, routeOrder.order.factoryLocation),
    choose(routeOrder.deliveryAddress, transport.deliveryAddresses, routeOrder.order.deliveryLocation),
  );
}
